import Vue from "vue";
export const eventBus = new Vue();

export const emitEvent = (event: string) => {
  eventBus.$emit(event, true);
};
